import {TwoFactorAuthenticationSMSWithRouter, TwoFactorAuthenticationEmailWithRouter} from "./containers"

export const TwoFactorAuthenticationSMS = TwoFactorAuthenticationSMSWithRouter
export const TwoFactorAuthenticationEmail = TwoFactorAuthenticationEmailWithRouter
